export enum DeviationEnum {
	DAMAGED_ITEM = 'DamagedItem',
	DELAYED_ARRIVAL = 'DelayedArrival',
	PARKING_LOT_OCCUPIED = 'ParkingLotOccupied',
	DELAYED_DEPARTURE = 'DelayedDeparture',
	MISSING_ITEM = 'MissingItem',
	POWER_SUPPLY_DAMAGED = 'PowerSupplyDamaged',
	POWER_SUPPLY_NOT_CONNECTED = 'PowerSupplyNotConnected',
	POWER_SUPPLY_NO_FUEL = 'PowerSupplyNoFuel',
}